import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { BoQPage } from './pages/BoQPage';
import { CurvaSPage } from './pages/CurvaSPage';
import TasksPage from './pages/TasksPage';
import CostControlPage from './pages/CostControlPage';
import SchedulePage from './pages/SchedulePage';
import DashboardPage from './pages/DashboardPage';
import MainDashboardPage from './pages/MainDashboardPage';
import ProjectsPage from './pages/ProjectsPage';
import { SettingsPage } from './pages/SettingsPage';
import { MainLayout } from './components/layout/MainLayout';
import CreateProjectPage from './pages/CreateProjectPage';

// eslint-disable-next-line @typescript-eslint/naming-convention
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <MainLayout>
          <Routes>
            <Route path="/dashboard" element={<MainDashboardPage />} />
            <Route path="/projects/new" element={<CreateProjectPage />} />
            <Route path="/projects/:projectId/dashboard" element={<DashboardPage />} />
            <Route path="/projects/:projectId/boq" element={<BoQPage />} />
            <Route path="/projects/:projectId/schedule" element={<SchedulePage />} />
            <Route path="/projects/:projectId/cost" element={<CostControlPage />} />
            <Route path="/projects/:projectId/curva" element={<CurvaSPage />} />
            <Route path="/projects/:projectId/tasks" element={<TasksPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/" element={<ProjectsPage />} />
          </Routes>
        </MainLayout>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
